export { NgxCarouselModule } from './src/ngx-carousel.module';
export { NgxCarousel, NgxCarouselStore } from './src/ngx-carousel/ngx-carousel.interface';